import { useQueries, useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../lib/queryKeys';
import { fetchVotingBoxes, fetchVotingStats, fetchVotingPublicLink, fetchMyVotingBoxes } from '../../lib/api';

export function useMyVotingBoxes() {
  return useQuery({
    queryKey: queryKeys.myVotingBoxes(),
    queryFn: fetchMyVotingBoxes,
  });
}

export function useVotingBoxes(campaignId) {
  return useQuery({
    queryKey: queryKeys.votingBoxes(campaignId),
    queryFn: () => fetchVotingBoxes(campaignId),
    enabled: !!campaignId,
  });
}

export function useVotingStats(campaignId) {
  return useQuery({
    queryKey: queryKeys.votingStats(campaignId),
    queryFn: () => fetchVotingStats(campaignId),
    enabled: !!campaignId,
  });
}

export function useVotingPublicLink(campaignId) {
  return useQuery({
    queryKey: queryKeys.votingPublicLink(campaignId),
    queryFn: () => fetchVotingPublicLink(campaignId),
    enabled: !!campaignId,
  });
}

/** Combines boxes + stats for FiyavalhuPage */
export function useVotingData(campaignId) {
  const boxes = useVotingBoxes(campaignId);
  const stats = useVotingStats(campaignId);
  const publicLink = useVotingPublicLink(campaignId);

  return {
    boxes,
    stats,
    publicLink,
    isLoading: boxes.isLoading || stats.isLoading,
    isError: boxes.isError || stats.isError,
    error: boxes.error || stats.error,
    refetch: () => {
      boxes.refetch();
      stats.refetch();
      publicLink.refetch();
    },
  };
}
